import api from './api';

const API_URL = '/budget/mutuo-banca';

export const getMutuoBanca = async (cantiereId) => {
  const res = await api.get(`${API_URL}/${cantiereId}`);
  return res.data;
};

export const saveMutuoBanca = async (cantiereId, dati) => {
  const res = await api.post(`${API_URL}/${cantiereId}`, dati);
  return res.data;
};
